import React, { useEffect, useState } from "react";
import StepWizard from "react-step-wizard";
import EditBankInfo from "./EditBankInfo";
import EditBasicInfo from "./EditBasicInfo";
import EditDocuments from "./EditDocuments";
import EditMeals from "./EditMeals";
import EditPlans from "./EditPlans";
import RestaurantTabNav from "../RestaurantTabNav";
import { useSelector, useDispatch } from "react-redux";

import { useParams } from "react-router";
import Loading from "../../../../utilities/Loading";
import { editBasicInfo, getRestaurant, updateRestaurant } from "../../../../actions/restaurantAction";
import axios from "axios";
import CustomRadio from "../../customs/CustomRadio";

export default function EditRestaurant(props) {
  const { restaurant } = useSelector(state => state)

  const [state, setState] = useState({});

  const [loaded, setLoaded] = useState(false);
  const [status, setStatus] = useState("")


  const onRadioSelected = (value) => {
    // const { value } = target
    setStatus(value)
    console.log(value);
    // dispatch(updateRestaurant(id, { status: value }))
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoaded(false);
    const response = await axios.put('/api/newrest/' + id, restaurant)
    const { data } = response
    setLoaded(true);
  };

  const { id } = useParams();
  const dispatch = useDispatch()

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      async function fetchData() {
        await dispatch(getRestaurant(id))
      }
      fetchData(id);
      setLoaded(true);
    }
    return () => {
      componentMounted = false;
    };
  }, [id]);

  useEffect(() => {
    let componentMount = true
    if (componentMount) {
      setState(restaurant)
    }
    return () => {
      componentMount = false
    }
  }, [loaded, id])

  useEffect(() => {
    let componentMount = true
    if (componentMount) {
      setStatus(restaurant.status)
    }
    return () => {
      componentMount = false
    }
  }, [restaurant])


  if (loaded) {
    return (
      <div className="wrapper wrapper-content">
        <div className="ibox">
          <div className="ibox-title">
            <h5>Edit Restaurant</h5>
          </div>
          <div className="ibox-content">
            <form
              className="wizard-big"
              onSubmit={(e) => onSubmit(e)}
            >
              <div className="row justify-content-end mt-2">
                <CustomRadio
                  name="status"
                  values={['Unapproved', 'Active', 'Inactive']}
                  handler={onRadioSelected} />
              </div>
              <br />
              <StepWizard
                isHashEnabled={false}
                nav={<RestaurantTabNav {...props} />}
              >
                <EditBasicInfo stepName={"Basic"} restaurant={state} />
                <EditDocuments stepName={"Documents"} restaurant={state} />
                <EditMeals stepName={"Meals"} restaurant={state} />
                <EditPlans stepName={"Plans"} restaurant={state} />
                <EditBankInfo stepName={"Bank Info"} restaurant={state} />
              </StepWizard>
            </form>
          </div>
        </div>
      </div>
    );
  } else {
    return <Loading />;
  }
}
